export const locale = {
  GLOBAL: {
    Title: "SMS Land",
    PostalCode: "Code postal",
    postalCodes: "Codes postaux",
    selectedPostalCodes: "Codes postaux sélectionnés",
    MciNumberCount: "Nombre de numéros MCI",
    MtuNumberCount: "Nombre de numéros Irancell",
    TotalCount: "Nombre total",
    Coefficient: "Coefficient",
    Back: "Retour",
  },
  ERRORS: {
    PhoneIsNotValid:
      "Le numéro de téléphone saisi est incorrect : exemple 09101234567",
    InvalidNumber: "Le nombre saisi est incorrect",
    NoSelectedLineNumber: "Veuillez sélectionner la ligne d’envoi.",
    EmptyText: "Veuillez saisir le texte.",
    UnknownError: "Erreur inconnue",
    TryAgain: "Veuillez réessayer dans quelques instants.",
    NoAccountCharge: "Solde insuffisant",
    NoAccess: "Accès refusé.",
    PleasebyeAPlane: "Veuillez acheter un forfait.",
    PleaseChargeYourAccount: "Veuillez recharger votre compte.",
    AccessDenied: "Accès refusé.",
    AccessDeniedDescription: "Pour plus d’informations, contactez le support",
    Error: "Erreur",
    InvalidText: "Texte invalide",
    InvalidTextContainsLink:
      "Seuls les numéros de service peuvent contenir des liens.",
  },
  INFOS: {
    SuccessSentSms: "Message envoyé",
    SmsRequestInQueue:
      "Votre message sera envoyé après validation par l’administrateur",
    SendData: "Informations d’envoi",
    CheckData: "Veuillez lire et confirmer les informations ci-dessous.",
  },
  TOBE: {
    to: "à ",
    from: "de ",
  },
  FORMS: {
    DestinationPhone: "Numéro du destinataire",
    TestDestinationPhone: "Numéro de test",
    SourceNumber: "Numéro expéditeur",
    Text: "Texte",
    CharCount: "Nombre de caractères",
    FarsiCharCount: "Caractères persans",
    EnglishCharCount: "Caractères latins",
    Send: "Envoyer",
    SendTime: "Date/heure d’envoi",
    SendTest: "Envoi test",
    SendToTestNumber: "Envoyer au numéro test",
    SmsCount: "Nombre de SMS",
    SmsLang: "Langue du SMS",
    Add: "Ajouter",
    FromFile: "Ajouter depuis un fichier",
    TestNumber: "Numéro test",
    Test: "Test",
    ServiceRelated: "Service",
    Price: "Prix",
    NumbersCount: "Nombre de numéros",
    NumbersCountToSend: "Nombre de destinataires",
    Search: "Rechercher",
    Title: "Titre",
    RequestTime: "Date de la demande",
    RequestInformation: "Informations de la demande",
    CreateNewPhoneBook: "Créer un nouveau carnet d’adresses",
  },
  BUTTONS: {
    OK: "OK",
    AccountCharge: "Recharger le compte",
    Reports: "Rapports",
    RemoveAll: "Tout supprimer",
    BuyAPlane: "Acheter un forfait",
    Accept: "Accepter",
    Reject: "Refuser",
    Yes: "Oui",
    No: "Non",
    Create: "Créer",
    New: "Nouveau",
    Save: "Enregistrer",
    Delete: "Supprimer",
    More: "Plus",
    TryAgain: "Réessayer",
    Close: "Fermer",
    RollBack: {
      back: "Retour à l’utilisateur précédent",
      goToMainUser: "Retour à l’utilisateur principal",
      CurrentUser: "Utilisateur actuel",
    },
  },
  DIALOGS: {
    Waiting: "Veuillez patienter",
    RejectItQuestion: "Refuser ?",
    AcceptItQuestion: "Accepter ?",
    Rejected: "Refusé",
    Accepted: "Accepté",
    Error: "Erreur",
  },
  CONFIRM: {
    Delete: "Êtes-vous sûr de vouloir supprimer ?",
    DeleteA: "Êtes-vous sûr de vouloir supprimer {a} ?",
    DeleteALL: "Êtes-vous sûr de vouloir tout supprimer ?",
  },
  LANGUAGE: {
    English: "Anglais",
    Persian: "Persan",
  },
  language: {
    selectAll: "Tout sélectionner",
    lang: {
      fa: "Persan",
      ar: "Arabe",
      ar_ae: "Arabe (EAU)",
      ar_iq: "Arabe (Irak)",
      en_US: "Anglais (USA)",
      en_GB: "Anglais (RU)",
      de: "Allemand",
      fr: "Français",
      zh_CN: "Chinois simplifié",
      zh_TW: "Chinois traditionnel",
      tr: "Turc",
      ru: "Russe",
      hy: "Arménien",
    },
    only_manual_now:
      "Seule la traduction manuelle est disponible pour le moment",
    ai_coming_soon: "La traduction IA sera activée bientôt",
    got_it: "Compris",
    origin_language: "Langue source",
    target_languages: "Langues cibles",
    remove_all: "Supprimer toutes les langues",
    translation_method: "Choisir la méthode de traduction",
    manual_translation: "Traduction manuelle",
    ai_translation: "Traduction IA",
    coming_soon: "Bientôt disponible",
    source_language_updated: "Langue source mise à jour",
    error_changing_source_language:
      "Erreur lors du changement de langue source",
    source_language_created: "Nouvelle langue source créée",
    languages_saved: "Nouvelles langues enregistrées",
    error_saving_languages: "Erreur lors de l'enregistrement des langues",
    error_loading_language: "Erreur de chargement de la langue",
    languages_removed: "Langues supprimées",
    new_languages_to_save: "Nouvelles langues à enregistrer",
    saved: "Enregistré",
    management_langs: "Gestion des langues",
    add_langs: "Ajouter une langue",
    change_language: "Changer de langue",
    visit_card: "Carte de visite",
    translate_to: "Traduire vers",
    main_language: "Langue",
    no_languages_available: "Aucune langue disponible",
    return_to_default: "Retour à la langue par défaut",
    translate: "Traduire",
    changes_pending: "En attente de l'application des modifications",
    apply_changes: "Appliquer les modifications",
    cancel_changes: "Annuler",
  },

  LISTS: {
    NoData: "Aucune donnée",
    NoDataFound: "Aucune donnée trouvée",
    NoDataFoundFor: "Aucune donnée trouvée pour {a}",
    NoPhoneNumber: "Aucun numéro trouvé",
    NoPostalCode: "Aucun code postal trouvé",
    AddANumber: "Ajoutez un numéro",
    City: "Ville",
    AddedBefore: "Déjà ajouté",
  },
  PAGES: {
    SendSms: "Envoyer un SMS",
    MapSms: "Envoi par carte",
    PhoneBook: "Carnet d’adresses",
  },
  MONETARY: {
    Rial: "Rial",
  },
  HINTS: {
    SendMessageTitle:
      "Le titre est un nom libre. Vous pouvez réutiliser le titre d’un message précédent pour que le texte soit automatiquement inséré. Le titre n’apparaît pas dans le message envoyé – il sert uniquement aux rapports et suggestions.",
    SendMessageTime:
      "L’heure d’envoi correspond au moment où votre message entre dans la file d’attente. Attention : sans validation de l’administrateur, le message ne sera pas envoyé.",
    CreatePhoneBook:
      "Ce nom sera utilisé lors de l’ajout de numéros pendant l’envoi de SMS.",
  },
  TOASTS: {
    SuccessCreate: "Créé avec succès",
    FailedCreated: "Erreur lors de la création",
    SuccessDelete: "Supprimé",
    FailedDelete: "Erreur lors de la suppression",
    SuccessEdit: "Modifié avec succès",
    FailedEdit: "Erreur lors de la modification",
    AddedSuccess: "Ajouté",
    AddedFailed: "Erreur lors de l’ajout",
  },
  WALLET: {
    CustomCharge: "Montant personnalisé",
    GateWay: "Passerelle de paiement",
    Price: "Montant",
    Details: [
      "9 % de taxe seront ajoutés au montant saisi.",
      "Veuillez saisir le montant avec soin – le montant versé n’est en aucun cas remboursable.",
    ],
    noGateWay: "Aucune passerelle de paiement n’est définie pour vous.",
    PriceNotInRange: "Le montant doit être compris entre {min} et {max} rials.",
    Pay: "Payer",
    ErrorOnRedirectToGateWay:
      "Erreur lors de la redirection vers la passerelle de paiement",
    ChargeWalletButtonDescription:
      "Cliquez sur le bouton + pour recharger votre compte",
  },
  login: {
    phoneField: {
      placeholderIran: "Commencez par 9 (ex : +98 912 345 6789)",
      placeholderDefault: "Saisissez votre numéro de téléphone",
      maxDigitsError: "Maximum {count} chiffres autorisés !",
      iranMustStartWith9: "Le numéro mobile doit commencer par 9 (ex : 912…)",
    },
    signup_button: "Je m’inscris !",
    forget_password_title: "Mot de passe oublié",
    register_title: "Inscription gratuite",
    login_title: "Connexion",
    back: "Retour",
    username_label: "Numéro de mobile / Nom d’utilisateur",
    otp_resend_button: "Renvoyer le code",
    password_label: "Mot de passe",
    password_hint: "Minimum 8 caractères",
    name_label: "Prénom",
    name_rule: "Minimum 3 caractères",
    lastname_label: "Nom de famille",
    phone_label: "Téléphone mobile",
    nid_label: "Numéro national",
    parent_phone_label: "Téléphone du parrain (facultatif)",
    terms_and_conditions_message:
      "L’inscription vaut acceptation des conditions générales du terminal publicitaire.",
    terms_and_conditions_link: "Conditions générales",
    close: "Fermer",
    forgot_password_link: "Mot de passe oublié ?",
    change_password: "Changer le mot de passe",
    register_button: "S’inscrire",
    login_button: "Se connecter",
    login_with_google: "Connexion avec Google",
    login_with_sms: "Connexion par SMS",
    login_with_password: "Connexion par mot de passe",
    already_registered: "Déjà inscrit ?",
    login_here: "Se connecter",
    no_account: "Pas encore de compte ?",
    signup_now: "Inscrivez-vous maintenant !",
    more_info: "Plus d’informations",
    text_login: "Connexion",
    text_register: "Inscription",
    required_field: "Champ obligatoire.",
    min_8_char: "Le champ contient moins de 8 caractères",
    required: "Ce champ est requis",
    min_3_char: "Minimum 3 caractères",
    max_50_char: "Maximum 50 caractères",
    no_internet: "Vous n’êtes pas connecté à Internet",
    no_phone_entered: "Vous n’avez saisi aucun numéro",
    otp_sent_successfully: "Code de validation envoyé avec succès.",
    please_register_first: "Veuillez d’abord vous inscrire !",
    wait_3_min: "Veuillez patienter 3 minutes avant de réessayer.",
    login_successful: "Connexion réussie",
    internet_connection_error: "Problème de connexion Internet !",
    agree_to_terms_error: "Vous n’avez pas accepté les conditions générales !",
    otp_sent_successfully_register: "Code de validation envoyé avec succès.",
    error: "Erreur",
    registration_nid_required_notice:
      "Pour garantir une sécurité maximale et prévenir toute fraude (phishing) ou utilisation abusive du système, la saisie du numéro national est obligatoire lors de l’inscription sur le terminal publicitaire.",
  },
  home: {
    title: "Accueil",
    selectSystem: "Choisir le système",
    yourPoints: "Vos points",
    discountCodes: "Codes promo",
    all: "Tous",
    discounts: "Promotions",
    systemGuide: "Guide du système",
    yourPointsDynamic: "Vos points : {points}",
    confirm: "Confirmer",
    copy: "Copier",
  },
  badges: {
    free: "Gratuit",
    preRegister: "Pré-inscription",
    comingSoon: "Bientôt disponible",
    testVersion: "Version bêta",
  },
  services: {
    qrLand: {
      title: "QR Land",
      description: "Création de QR codes dynamiques",
      property: {
        0: "Examen et choix du type et du lieu de publicité",
        1: "Examen et choix des publicités cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée de toutes les publicités dans les cinémas",
      },
    },
    payamak: {
      title: "SMS Land",
      description: "Envoi de SMS publicitaires en masse",
      property: {
        0: "Envoi de SMS en masse",
        1: "Base de numéros à jour",
        2: "Envoi aux clubs clients",
        3: "Connexion à tous les sites et logiciels",
      },
    },
    robot: {
      title: "Robot Land",
      description:
        "Gestion simultanée de tous les numéros, annonces et panneaux",
      property: {
        0: "Publication groupée et massive d’annonces",
        1: "Gestion programmée, progressive et intelligente des annonces",
        2: "Location et ajout illimité de numéros",
        3: "Publication et gestion simultanée de toutes les annonces",
      },
    },
    infoLand: {
      title: "Info Land",
      description: "Plus de 2500 bases de données professionnelles à jour",
      property: {
        0: "Toutes les données professionnelles disponibles",
        1: "Classement par ville et province",
        2: "Base complète de tous les corps de métier du pays",
        3: "Possibilité de consulter des échantillons",
      },
    },
    graphic: {
      title: "Graphic Land",
      description: "Design graphique et vidéo de A à Z",
      property: {
        0: "Création de logos et charte graphique",
        1: "Tous les services d’impression et packaging",
        2: "Conception de catalogues, brochures et boîtes",
        3: "Conception et impression de bannières tous formats",
      },
    },
    bestWebLand: {
      title: "Best Web Land",
      description: "Création, maintenance et SEO de sites web",
      property: {
        0: "SEO de contenu",
        1: "SEO off-page",
        2: "SEO technique",
        3: "SEO on-page",
      },
    },
    onlineShop: {
      title: "Créateur de boutique en ligne",
      description: "À quelques clics du monde numérique",
      badge: "Affiliation",
      property: {
        0: "SEO de contenu",
        1: "SEO off-page",
        2: "SEO technique",
        3: "SEO on-page",
      },
    },
    social: {
      title: "Publicité sur les réseaux sociaux",
      description: "Examen et choix des meilleures pages et chaînes",
      property: {
        0: "Analyse des pages à forte audience",
        1: "Gestion centralisée de toutes les publicités",
        2: "Aucune commission ni frais supplémentaires",
        3: "Réservation en ligne sur les pages sélectionnées",
      },
    },
    billboard: {
      title: "Location de panneaux publicitaires en ligne",
      description: "Sans intermédiaire, ciblage précis",
      property: {
        0: "Analyse du lieu et du type de panneau",
        1: "Gestion de tous les panneaux disponibles",
        2: "Contact direct avec le propriétaire",
        3: "Aucune commission ni frais supplémentaires",
      },
    },
    internationalMedia: {
      title: "Publicité dans les médias nationaux",
      description: "Publicité TV et radio",
      property: {
        0: "Choix de la période de diffusion",
        1: "Choix des formats TV",
        2: "Choix des formats radio",
        3: "Choix du programme TV",
      },
    },
    transport: {
      title: "Publicité dans les transports en commun",
      description: "Aéroports, gares, bus et métro",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des publicités métro",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités métro",
      },
    },
    cinema: {
      title: "Publicité dans les médias visuels",
      description: "Cinéma et plateformes de streaming",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    estate: {
      title: "Système immobilier en ligne",
      description: "Gestion des biens, agents et clients",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    AIGeneration: {
      title: "Système d’intelligence artificielle",
      description: "Génération d’images, chatbots",
    },
    ShortLink: {
      title: "Raccourcisseur de liens",
      description: "Créer des liens courts",
    },
    customer: {
      title: "Gestion en ligne des clients",
      description: "Gestion, support et fidélisation",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    internetBroadcasting: {
      title: "Publicité et gestion en ligne",
      description: "Google Ads, publicité au clic, publi-reportages",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    emailMarketing: {
      title: "Email Marketing",
      description:
        "Envoi d’emails publicitaires à toutes les entreprises du pays",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    adsOnStudium: {
      title: "Publicité dans les stades et salons",
      description: "Présence de votre marque dans les plus grands lieux",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    bidOnline: {
      title: "Système complet d’enchères en ligne",
      description: "Créez ou participez à des enchères en ligne",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    onlineTools: {
      title: "Outils en ligne pour entreprises",
      description: "Tous les outils utiles pour toute activité",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    onlineLearn: {
      title: "Formation en ligne des métiers",
      description: "Choix ciblé de formations",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    cloud: {
      title: "Hébergement & achat de domaine",
      description: "Achat d’hébergement, domaine et serveur",
      property: {
        0: "Choix du type et du lieu de publicité",
        1: "Choix des formats cinéma",
        2: "Aucune commission ni frais supplémentaires",
        3: "Gestion centralisée des publicités cinéma",
      },
    },
    QrlandShop: {
  title: "Gestion des boutiques en ligne",
  description: "Gestion centralisée des produits, des places de marché et de la tarification intelligente",
  property: {
    0: "Suivi et gestion complets des produits",
    1: "Gestion des variantes de produits",
    2: "Suivi et gestion des places de marché",
    3: "Stratégies de tarification intelligente",
  },
},

  },
  "planning.title": "Planification",
  "tabs.reminder": "Rappels",
  "tabs.notes": "Notes",
  "tabs.calendar": "Calendrier",
  "notes.creationDate": "Date de création",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "actions.quickActions": "Actions rapides",
  "notes.writeMessage": "Écrire une note",
  "notes.titlePlaceholder": "Titre de la note",
  "notes.addNote": "Ajouter une note",
  "notes.updatedSuccess": "Note mise à jour avec succès.",
  "notes.addedSuccess": "Note ajoutée avec succès.",
  "common.deletedSuccess": "Supprimé avec succès",
  "common.confirmDelete": "Êtes-vous sûr de vouloir supprimer ?",
  "news.title": "Actualités du site",
  "news.noNews": "Aucune actualité n’a encore été publiée.",
  "news.view": "Voir",
  "remember.add": "Créer un rappel",
  "remember.update": "Mettre à jour le rappel",
  "remember.titleLabel": "Titre",
  "remember.dateLabel": "Date du rappel",
  "remember.confirmDelete": "Êtes-vous sûr de vouloir supprimer ?",
  "remember.deleteSuccess": "Rappel supprimé avec succès.",
  "remember.createSuccess": "Nouveau rappel créé.",
  "remember.updateSuccess": "Rappel mis à jour.",
  "points.receivedAwards": "Récompenses reçues",
  "points.pointsHistory": "Historique des points",
  "points.points": "Points",
  "points.discountTitle": "Remise Robot Land",
  "points.discountText": "Pour chaque 500 points",
  events: {
    title: "Événements",
    addEvent: "Ajouter un événement",
    calendar: "Calendrier de base",
    close: "Fermer",
    save: "Enregistrer",
    update: "Mettre à jour",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ?",
    successAdd: "Ajouté avec succès.",
    successDelete: "Événement supprimé avec succès.",
    successUpdate: "Mise à jour réussie.",
    titleLabel: "Titre",
    descriptionLabel: "Description",
    colorLabel: "Couleur",
    removeAfterDrop: "Supprimer après dépôt",
    createEvent: "Créer un événement",
  },
  copySuccess: "Copié avec succès.",
  copyTextTitle: "Copier",
  copiedTextTitle: "Copié",
  ribbon: {
    new: "Nouveau",
  },
  coupons: [
    {
      text: "Ce coupon est valable 3 semaines",
      title: "Texte unique 20 %",
    },
    {
      text: "Ce coupon est valable 2 semaines",
      title: "Création de site web 5 %",
    },
    {
      text: "Ce coupon n’est utilisable qu’une seule fois",
      title: "Gestion de page 10 %",
    },
    {
      text: "Ce coupon est activé de manière permanente pour vous",
      title: "Design graphique 5 %",
    },
    {
      text: "Ce coupon n’est utilisable qu’une seule fois",
      title: "Impression 2 %",
    },
  ],
  userLinks: {
    profile: {
      title: "Vue d’ensemble",
      invitation: { title: "Inviter des amis" },
      info: { title: "Informations personnelles" },
      edit: { title: "Compléter le profil" },
      changePass: { title: "Changer le mot de passe" },
    },
  },
  profileLinks: {
    orders: "Commandes",
    addresses: "Adresses",
  },
  customPage: {
    overview: "Vue d’ensemble",
    personalInfo: "Informations personnelles",
    changePassword: "Changer le mot de passe",
    completeProfile: "Compléter le profil",
    email: "E-mail",
    balance: "Solde",
    phone: "Numéro de téléphone",
    rial: "Rial",
  },
  widget12: {
    inviteFriends: "Inviter des amis",
    viewInvitedUsers: "Voir la liste des utilisateurs que vous avez parrainés",
    yourInviteCode: "Votre code d’invitation",
    createNewUser: "Créer un nouvel utilisateur",
    copyText: "Copier",
    userCreatedSuccess: "Nouvel utilisateur créé avec succès",
    notCreated: "Non créé",
  },
  userInfo: {
    userInformation: "Informations utilisateur",
    profilePicture: "Photo de profil",
    allowedFileTypes: "Types de fichiers autorisés : png, jpg, jpeg.",
    profilePictureSize:
      "La photo de profil doit être carrée (exemple : 480 × 480).",
    firstName: "Prénom",
    lastName: "Nom de famille",
    username: "Nom d’utilisateur",
    phone: "Numéro de contact",
    email: "E-mail",
    receiveSMS: "Recevoir des SMS",
    smsCostNote:
      "En activant cette option, les frais d’envoi des SMS seront déduits de votre solde.",
    saveChanges: "Enregistrer les modifications",
    profileUpdated: "Votre profil a été mis à jour avec succès.",
  },
  emailSettings: {
    completeProfile: "Compléter le profil",
    completeProfileDesc:
      "Compléter les informations personnelles ou professionnelles",
    cancel: "Annuler",
    update: "Mettre à jour",
    save: "Enregistrer",
    selectPersonType: "Sélectionnez le type de personne",
    realPerson: "Personne physique",
    legalPerson: "Personne morale",
    phone: "Mobile",
    landline: "Téléphone fixe",
    fatherName: "Nom du père",
    nationalCode: "Numéro national",
    idNumber: "Numéro de carte d’identité",
    birthday: "Date de naissance",
    placeOfBirth: "Lieu de naissance",
    postalCode: "Code postal",
    email: "E-mail",
    introduction: "Comment nous avez-vous connu ?",
    nationalCodePic: "Photo de la carte d’identité",
    plaque: "Numéro de plaque",
    address: "Adresse complète",
    companyName: "Nom de l’entreprise / du commerce",
    registrationNumber: "Numéro d’enregistrement",
    economicCode: "Code économique",
    organizationIdentity: "Numéro national de l’organisation",
    companyType: "Type d’entreprise",
    activity: "Domaine d’activité",
    registrationAd: "Image de l’annonce d’enregistrement de l’entreprise",
    lastPublishedAd: "Image de la dernière annonce officielle publiée",
    statute: "Image des statuts de l’entreprise",
    agentLetterPic: "Image de la lettre de présentation du représentant",
    successMessage: "Enregistré avec succès",
    errorSelectType: "Veuillez sélectionner une option.",
    rules: {
      companyName: "Le champ Nom de l’entreprise/commerce est obligatoire.",
      registrationNumber: "Le champ Numéro d’enregistrement est obligatoire.",
      economicCode: "Le champ Code économique est obligatoire.",
      organizationIdentity:
        "Le champ Numéro national de l’organisation est obligatoire.",
      registrationAd: "L’image de l’annonce d’enregistrement est obligatoire.",
      lastPublishedAd:
        "L’image de la dernière annonce officielle est obligatoire.",
      telephone: "Le champ Téléphone fixe est obligatoire.",
      fatherName: "Le champ Nom du père est obligatoire.",
      nationalCode: "Le champ Numéro national est obligatoire.",
      birthday: "Le champ Date de naissance est obligatoire.",
      idNumber: "Le champ Numéro de carte d’identité est obligatoire.",
      placeOfBirth: "Le champ Lieu de naissance est obligatoire.",
      postalCode: "Le champ Code postal est obligatoire.",
      nationalCodePic: "La photo de la carte d’identité est obligatoire.",
      address: "Le champ Adresse est obligatoire.",
      plaque: "Le champ Numéro de plaque est obligatoire.",
    },
    companyTypes: {
      governmental: "Public",
      private: "Privé",
      commonStock: "Société par actions (cotée)",
      specialStock: "SARL / Société par actions simplifiée",
    },
  },
  changePassword: {
    title: "Changer le mot de passe",
    description: "Modifiez le mot de passe de votre compte",
    cancel: "Annuler",
    update: "Mettre à jour",
    passwordInstructions: {
      forgotPassword:
        "Si vous n’avez jamais défini de mot de passe, cliquez sur « Mot de passe oublié ».",
      passwordRequirements:
        "Le mot de passe doit comporter au minimum 8 caractères, incluant chiffres, lettres majuscules et minuscules ainsi que des symboles.",
      passwordPrivacy: "Ne partagez jamais votre mot de passe avec quiconque.",
      keyboardLanguage:
        "Assurez-vous que votre clavier est en anglais lors de la saisie du mot de passe.",
    },
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    addOrForgotPassword: "Ajouter ou réinitialiser le mot de passe",
    changePasswordWithCode: "Changer le mot de passe par SMS",
    close: "Fermer",
    change: "Modifier",
    enterCode: "Saisir le code",
    successMessage: "Mot de passe mis à jour avec succès",
    invalidCode: "Le code saisi est incorrect.",
    tooManyAttempts: "Trop de tentatives !",
    rules: {
      required: "Ce champ est obligatoire.",
      min: "Le champ doit contenir au moins 8 caractères",
      equal: "Les deux mots de passe ne correspondent pas",
      number: "Saisissez les chiffres du numéro",
    },
  },
  router: {
    dashboard: "Tableau de bord",
    contacts: "Club clients",
    editContact: "Modifier le client",
    createContact: "Créer un client",
    customers: "Liste des clients",
    contactList: "Assistant de contact",
    messages: "Messages",
    messageCategories: "Catégories de messages",
    oldTransactions: "Anciennes transactions",
    yourTransactions: "Vos transactions",
    buyPanel: "Acheter un panel",
    permissions: "Autorisations",
    createPermission: "Créer une autorisation",
    invitations: "Mes invitations",
    editUser: "Modifier l’utilisateur",
    userInformation: "Voir les informations utilisateur",
    walletEdit: "Modifier le portefeuille utilisateur",
    userHistory: "Historique utilisateur",
    userNotificationsHistory: "Historique des notifications",
    notifications: "Notifications",
    createNotification: "Créer une notification",
    editNotification: "Modifier la notification",
    adminNotifications: "Notifications admin",
    yourNotifications: "Vos notifications",
    adminNotificationsList: "Notifications du gestionnaire",
    tickets: "Tickets",
    createTicket: "Créer un ticket",
    editTicket: "Modifier le ticket",
    departments: "Départements",
    createDepartment: "Nouveau département",
    editDepartment: "Modifier le département",
    adminTickets: "Gestion des tickets",
    discounts: "Réductions",
    createDiscount: "Créer une réduction",
    editDiscount: "Modifier la réduction",
    workReports: "Rapports de travail",
    createWorkReport: "Créer un rapport",
    callMonitoring: "Supervision des appels",
    adminWorkReports: "Gestion des rapports de travail",
    editWorkReport: "Voir et modifier le rapport",
    packProperties: "Caractéristiques des forfaits",
    createPackProperty: "Créer une caractéristique",
    editPackProperty: "Modifier une caractéristique",
    panels: "Panels",
    createPanel: "Créer un panel",
    editPanel: "Modifier le panel",
    transferRequests: "Demandes de retrait",
    editTransferRequest: "Modifier la demande de retrait",
    tariffs: "Tarifs",
    createTariff: "Créer un tarif",
    editTariff: "Modifier le tarif",
    requests: "Demandes",
    viewUser: "Voir l’utilisateur",
    manageTransactions: "Gérer les transactions",
    viewTransaction: "Voir la transaction",
    manageConfigs: "Gérer les paramètres",
    rbLandConfigs: "Paramètres Robot Land",
    editConfig: "Modifier les paramètres",
    manageUsers: "Gestion des utilisateurs",
    categories: "Catégories",
    createCategory: "Ajouter une catégorie",
    editCategory: "Modifier la catégorie",
    content: "Contenu",
    createContent: "Ajouter du contenu",
    editContent: "Modifier le contenu",
    addUserGuide: "Ajouter un guide utilisateur",
    editUserGuide: "Modifier le guide utilisateur",
    roles: "Rôles",
    editRole: "Modifier le rôle",
    createRole: "Ajouter un rôle",
    permissionTitle: "Autorisations",
    paymentGateways: "Passerelles de paiement",
    editPaymentGateway: "Modifier la passerelle",
    campaigns: "Campagnes",
    createCampaign: "Créer une campagne",
    editCampaign: "Modifier la campagne",
    adminCustomers: "Clients",
    createCustomer: "Créer un client",
    editCustomerInfo: "Modifier les infos client",
    referrerCustomers: "Clients parrainés",
    customerHistory: "Historique client",
    userProfile: "Profil utilisateur",
    editProfile: "Modifier le profil",
    inviteFriends: "Inviter des amis",
    personalInfo: "Informations personnelles",
    editPersonalInfo: "Modifier les informations",
    changePassword: "Changer le mot de passe",
    newWallet: "Nouveau portefeuille",
  },
  profileView: {
    email: "E-mail",
    balance: "Solde",
    personType: "Type de personne",
    currency: "Rial",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "Vous possédez le panel {title} ({days} jours).",
    buyOrRenew:
      "Cliquez sur le bouton ci-dessous pour acheter ou renouveler votre panel.",
    buyPanel: "Acheter un panel",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Paramètres du profil",
    changePasswordTitle: "Changer le mot de passe",
    changePasswordSubtitle: "Modifiez votre mot de passe de connexion.",
    alertMessage:
      "Si vous n’avez jamais défini de mot de passe, cochez l’option « Définir un mot de passe ».",
    currentPasswordLabel: "Mot de passe actuel",
    setPasswordLabel: "Définir un mot de passe",
    addPassword: "Ajouter un mot de passe",
    newPasswordLabel: "Nouveau mot de passe",
    repeatPasswordLabel: "Répéter le mot de passe",
    saveChanges: "Enregistrer les modifications",
    currentPasswordPlaceholder: "Mot de passe actuel",
    newPasswordPlaceholder: "Nouveau mot de passe",
    repeatPasswordPlaceholder: "Répéter le mot de passe",
  },
  profileOrders: {
    cardTitle: "Commandes",
    openOrders: "Commandes en cours ({count})",
    closedOrders: "Commandes terminées ({count})",
    noOrders: "Vous n’avez encore rien commandé chez nous",
  },
  personalInformation: {
    cardTitle: "Informations du compte personnel",
    cardSubtitle: "Mettez à jour vos informations personnelles.",
    cancel: "Annuler",
    update: "Mettre à jour",
    yourInfo: "Vos informations",
    profilePicture: "Photo de profil",
    allowedFileTypes: "Types de fichiers autorisés : png, jpg, jpeg.",
    pictureSize: "La photo de profil doit être carrée (exemple : 480 × 480).",
    name: "Prénom",
    lastName: "Nom de famille",
    username: "Nom d’utilisateur",
    receiveSMS: "Recevoir des SMS",
    smsCostNote:
      "En activant cette option, les frais d’envoi des SMS seront déduits de votre solde.",
    phoneNumber: "Numéro de mobile",
    phonePlaceholder: "Numéro de mobile",
    email: "E-mail",
    emailPlaceholder: "E-mail",
    emailPrivacy: "Nous ne partagerons jamais votre e-mail avec des tiers.",
    successMessage: "Votre profil a été mis à jour avec succès.",
  },
  userInfoForm: {
    companyName: "Nom de l’entreprise / du commerce",
    registrationNumber: "Numéro d’enregistrement",
    economicCode: "Code économique",
    organizationIdentity: "Numéro national de l’organisation",
    companyType: "Type d’entreprise",
    activity: "Domaine d’activité",
    registrationAd: "Image de l’annonce d’enregistrement",
    lastPublishedAd: "Image de la dernière annonce officielle publiée",
    statute: "Image des statuts de l’entreprise",
    argentLetterPic: "Image de la lettre de présentation du représentant",
    phone: "Mobile",
    telephone: "Téléphone fixe",
    fatherName: "Nom du père",
    nationalCode: "Numéro national",
    id: "Numéro de carte d’identité",
    birthday: "Date de naissance",
    placeBirthday: "Lieu de naissance",
    postalCode: "Code postal",
    email: "E-mail",
    introduction: "Comment nous avez-vous connu ?",
    nationalCodePic: "Photo de la carte d’identité",
    plaque: "Numéro de plaque",
    address: "Adresse complète",
    companyTypes: {
      governmental: "Public",
      private: "Privé",
      common_stock: "Société par actions (cotée)",
      special_stock: "SARL / Société par actions simplifiée",
    },
    rules: {
      companyName: "Le champ Nom de l’entreprise/commerce est obligatoire.",
      registration_number: "Le champ Numéro d’enregistrement est obligatoire.",
      economic_code: "Le champ Code économique est obligatoire.",
      organization_identity:
        "Le champ Numéro national de l’organisation est obligatoire.",
      registration_ad: "L’image de l’annonce d’enregistrement est obligatoire.",
      last_published_ad:
        "L’image de la dernière annonce officielle est obligatoire.",
      telephone: "Le champ Téléphone fixe est obligatoire.",
      fatherName: "Le champ Nom du père est obligatoire.",
      nationalCode: "Le champ Numéro national est obligatoire.",
      id: "Le champ Numéro de carte d’identité est obligatoire.",
      birthday: "Le champ Date de naissance est obligatoire.",
      placeBirthday: "Le champ Lieu de naissance est obligatoire.",
      postalCode: "Le champ Code postal est obligatoire.",
      nationalCodePic: "La photo de la carte d’identité est obligatoire.",
      address: "Le champ Adresse est obligatoire.",
      plaque: "Le champ Numéro de plaque est obligatoire.",
    },
  },
  createUserForm: {
    name: "Prénom",
    lastName: "Nom de famille",
    nid: "Numéro national",
    phone: "Numéro de mobile",
    create: "Créer",
    errors: {
      nameRequired: "Le prénom n’a pas été saisi !",
      lastNameRequired: "Le nom de famille n’a pas été saisi !",
      nidRequired: "Le numéro national n’a pas été saisi !",
      phoneRequired: "Le numéro de mobile n’a pas été saisi !",
    },
  },
  lastView: {
    cardTitle: "Vos dernières visites",
    cardSubtitle: "Les dernières pages que vous avez consultées",
    tableHeaders: {
      page: "Page",
      address: "Adresse",
      enterDate: "Date d’entrée",
      leaveDate: "Date de sortie",
      timeSpent: "Temps passé sur la page",
    },
    viewAll: "Voir tout",
    timeUnit: "minutes",
    pages: {
      home: "Accueil",
      panels: "Panels",
      profile: "Compléter le profil",
    },
  },
walletWidget: {
  title: "Transactions récentes",
  balanceLabel: "Votre solde :",
  viewTransactions: "Voir les transactions",
  transactionTypes: {
    withdraw: "Retrait",
    deposit: "Dépôt",
    charge: "Recharge du portefeuille",
    refund: "Remboursement",
    default: "Transaction",
    adminCharge: "Ajustement administrateur",
    agency: "Commission d'agence",
  },
},
  panelWidget: {
    title: "Vous possédez le panel {title} ({days} jours).",
    renewPrompt:
      "Cliquez sur le bouton ci-dessous pour acheter ou renouveler votre panel.",
    buyPanel: "Acheter un panel",
    percentage: "{value} %",
    infinity: "∞",
    days: "{count} jours",
  },
  component: {
    title: "Utilisateurs parrainés par vous",
    columns: {
      row: "N°",
      name: "Prénom",
      family: "Nom de famille",
      username: "Nom d’utilisateur",
      phone: "Mobile",
      created_at: "Date d’inscription",
      actions: "Actions",
    },
    unknown: "Inconnu",
    error: "Erreur",
    breadcrumb: "Utilisateurs parrainés",
  },
  table: {
    itemsPerPage: "Lignes par page",
    pageText: "Affichage de {0} à {1} sur {2} entrées",
    prevText: "Précédent",
    nextText: "Suivant",
    noDataText: "Aucune donnée disponible",
    search: "Rechercher",
  },
  UserHistory: {
    title: "Historique des utilisateurs",
    add_history: "Ajouter un historique",
    send_message: "Envoyer un message",
    close: "Fermer",
    save: "Enregistrer",
    cancel: "Annuler",
    new_history_dialog_title: "Nouvel historique",
    send_message_dialog_title: "Envoyer un message",
    negotiations: "Négociations réalisées",
    follow_up: "Points à suivre lors du prochain contact",
    success_history: "Historique enregistré avec succès.",
    success_message: "Message envoyé avec succès.",
    columns: {
      id: "ID",
      title: "Titre",
      status: "Étape",
      current_time_date: "Date du dernier contact",
      current_time_hour: "Heure du dernier contact",
      next_time_date: "Date du prochain contact",
      next_time_hour: "Heure du prochain contact",
      user_id: "Support",
      actions: "Actions",
    },
    table: {
      itemsPerPage: "Lignes par page",
      pageText: "Affichage de {0} à {1} sur {2} entrées",
      prevText: "Précédent",
      nextText: "Suivant",
      noDataText: "Aucune donnée disponible",
      search: "Rechercher",
    },
    form: {
      title: "Titre",
      status: "Étape",
      current_time: "Date du dernier contact",
      description: "Description",
      next_time: "Date du prochain contact",
      pursue_text: "Suivi du prochain contact",
      category: "Choisir une catégorie",
      message_title: "Titre du message",
    },
  },
  newUserTransactions: {
    userWallet: "Portefeuille utilisateur",
    transactionList: "Liste des transactions",
    userTransactions: "Transactions de l’utilisateur",
    terminal: "Terminal",
    liveSms: "SMS en direct",
    realEstateNews: "Nouveautés Divar",
    rial: "Rial",
    row: "N°",
    uniqueId: "ID",
    amount: "Montant",
    time: "Heure",
    createdAt: "Date",
    description: "Description détaillée",
    type: "Type de transaction",
    product_description: "Description",
    serviceId: "Nom du service",
    balanceAfter: "Solde après transaction",
    perPage: "Nombre",
    search: "Rechercher",
    balance: "Solde",
    transactionListTooltip: "Liste des transactions",
    panelLogin: "Connexion au panel",
    history: "Historique",
    error: {
      terminalWallet: "Erreur lors de la récupération du portefeuille terminal",
      imageLoad: "Erreur lors du chargement de l’image !",
    },
    transactionType: "Type de transaction",
    service: "Service",
    dateFrom: "Date de début",
    dateTo: "Date de fin",
    oldWallet: "Ancien portefeuille",
    depositReceipt: "Reçu de dépôt",
    showReceipt: "Afficher le reçu",
    transactionTypes: {
      online: "En ligne",
      admin: "Par l’administrateur",
      refund: "Transaction corrective",
      agency: "Agence",
      withdraw: "Retrait",
      deposit: "Dépôt",
      adminCharge: "Transaction par admin",
      charge: "Recharge portefeuille",
      refund: "Remboursement",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Veuillez choisir le type de panel avec soin !",
    },
    dialog: {
      title: "Achat de panel",
      confirmPurchase:
        "Êtes-vous sûr de vouloir acheter le panel « {title} » ?",
      discountCodeLabel: "Code promo",
      discountCodePlaceholder: "Saisissez votre code promo",
      applyDiscount: "Appliquer le code",
      purchase: "Acheter",
      iHaveDiscount: "J’ai un code promo",
    },
    toast: {
      discountApplied: "Votre code promo a été appliqué avec succès !",
      purchaseSuccess: "Forfait acheté avec succès",
      error: "Une erreur est survenue : {message}",
      unauthorized: "Veuillez d’abord vous connecter",
      validationError: "Erreur de validation : {message}",
    },
    currency: "Rial",
  },
  panelCard: {
    rial: "Rial",
    days: "jours",
    buyPanel: "Acheter un panel",
  },
  cons: {
    title: "Choisir un emoji",
  },
  cons1: {
    title: "Texte par défaut",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Grand système de terminal publicitaire",
  },
};
